import * as angular from "angular";
import {IController} from "angular";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AiAgentModel} from "../../models/ai-agent.model";
import {AiAgentsHttpService} from "../../angular/services/ai-agents-http.service";
import {AiAgentsDialogService} from "../../services/ai-agents-dialog.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {AiAgentsAlertsService} from "../../services/ai-agents-alerts.service";

export class AiAgentsViewComponent implements IController {

  aiAgents: AiAgentModel[];

  public loadLimit = 20;
  public cursor: string;
  public isFetchingData: boolean;

  constructor(private aiAgentsDialogService: AiAgentsDialogService,
              private aiAgentsHttpService: AiAgentsHttpService,
              private aiAgentsAlertsService: AiAgentsAlertsService,
              private commonsFacadeService: CommonsFacadeService,
              private confirmDialogService: ConfirmDialogService,
              private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    this.getAiAgents();
  };

  onCreateAiAgent(event) {
    this.aiAgentsDialogService.createAiAgent(event)
      .then((payload) => {
        this.createAiAgent(payload);
      })
  }

  onEditAiAgent(aiAgent: AiAgentModel) {
    this.aiAgentsDialogService.editAiAgent(aiAgent)
      .then((payload) => {
        this.editAiAgent(payload);
      })
  }

  onDeleteAiAgent(aiAgent: AiAgentModel) {
    this.confirmDialogService.confirm('Delete AI Agent', 'Are you sure you want to delete this AI agent?', undefined)
      .then(() => {
        this.deleteAiAgent(aiAgent.id);
      })
  }

  getAiAgents(cursor?: string) {

    let params = {
      limit: this.loadLimit
    };

    if (cursor || this.cursor) {
      params['cursor'] = cursor ? cursor : this.cursor;
    }

    this.isFetchingData = true;
    this.commonsFacadeService.setLoaderOn();

    this.aiAgentsHttpService.getAiAgents(params).subscribe({
      next: (res) => {
        this.cursor = res.cursor;
        this.aiAgents = res.list;
      },
      error: (err) => {
        this.commonsFacadeService.setLoaderOff();
        this.isFetchingData = false;
      },
      complete: () => {
        this.commonsFacadeService.setLoaderOff();
        this.isFetchingData = false;
      }
    });
  }

  fetchNext() {
    if (!this.cursor || this.isFetchingData) {
      return;
    }
    this.getAiAgents(this.cursor);
  }

  private createAiAgent(aiAgent: AiAgentModel) {

    this.bringozLoaderService.on();

    this.aiAgentsHttpService.createAiAgent(aiAgent)
    .subscribe({
      next: (createdAiAgent) => {
        const copy = angular.copy(this.aiAgents);
        copy.unshift(createdAiAgent);
        this.aiAgents = copy;
        this.aiAgentsAlertsService.createSuccess();
      },
      error: (err) => {
        console.error(err);
        this.aiAgentsAlertsService.createError();
      },
      complete: () => {
        this.bringozLoaderService.off();
      }
    });
  }

  private editAiAgent(aiAgent: AiAgentModel) {

    this.bringozLoaderService.on();

    this.aiAgentsHttpService.updateAiAgent(aiAgent)
      .subscribe({
        next: (updatedAiAgent) => {
          const index = this.aiAgents.findIndex(a => a.id === updatedAiAgent.id);
          const copy = angular.copy(this.aiAgents);
          copy[index] = updatedAiAgent;
          this.aiAgents = copy;
          this.aiAgentsAlertsService.editSuccess();
        },
        error: (err) => {
          console.error(err);
          this.aiAgentsAlertsService.editError();
        },
        complete: () => {
          this.bringozLoaderService.off();
        }
      });
  }

  private deleteAiAgent(aiAgentId: string) {

    this.bringozLoaderService.on();

    this.aiAgentsHttpService.deleteAiAgent(aiAgentId)
      .subscribe({
        next: (updatedAiAgent) => {
          const index = this.aiAgents.findIndex(a => a.id === updatedAiAgent.id);
          const copy = angular.copy(this.aiAgents);
          copy.splice(index, 1);
          this.aiAgents = copy;
          this.aiAgentsAlertsService.deleteSuccess();
        },
        error: (err) => {
          console.error(err);
          this.aiAgentsAlertsService.deleteError();
        },
        complete: () => {
          this.bringozLoaderService.off();
        }
      });

  }

}

angular
  .module('bringoz.admin.ai-agents')
  .component('aiAgentsView', {
    bindings: {
      aiAgents: '<',
    },
    template: require('./ai-agents-view.html').default,
    controller: AiAgentsViewComponent
  });
